import FormItem from "components/Form/FormItem";
import ModalPhotos from "components/TripCard/ModalPhotos";
import { getUrl } from "functions/BaseAxios";
import { uploadIMG } from "functions/redux/general/action";
import { updateFormTripMass } from "functions/redux/listing/action";
import { RootStore } from "functions/redux/store";
import { errorAlert, errorAlert1 } from "functions/redux/user/action";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import ReactTextareaAutosize from "react-textarea-autosize";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Input from "shared/Input/Input";
import NcModal from "shared/NcModal/NcModal";

interface OpenStepThreeProps {
    form: any
}

const OpenStepThree: FC<OpenStepThreeProps> = ({ form }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState("");
    const [showButtonDelete, setshowButtonDelete] = useState(null);
    const [images, setImages] = useState(form?.productImages ?? []);
    const [imageIDs, setImageIDs] = useState(form?.file ?? []);
    const { general, listing } = useSelector((state: RootStore) => state);
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [openFocusIndex, setOpenFocusIndex] = useState(0);
    const [confimationModal, setConfirmationModal] = useState(false);
    const [idItem, setidItem] = useState(null);
    const [modalDescription, setModalDescription] = useState(null);
    const [textDescriptionImage, settextDescriptionImage] = useState("");

    const handleCloseModal = () => setIsOpen(false);
    const handleOpenModal = (index: number) => {
        setIsOpen(true);
        setOpenFocusIndex(index);
    };
    const uploadImage = async (event: any) => {
        setLoading("image");
        var img = await uploadIMG(event.target.files[0]);
        if (img.code === undefined) {
            images.push(img);
            if (listing.addOpenTrip?.id) {
                dispatch(updateFormTripMass({
                    "productImages": images,
                    // "file": imageIDs
                }));
            } else {
                imageIDs.push(img);
                dispatch(updateFormTripMass({
                    "productImages": images,
                    "file": imageIDs
                }));
            }

        } else {
            dispatch(errorAlert1('Something wrong !, maybe file image too large'));
        }
        setLoading("");
    }

    const findArrayIndex = (object: any) => {
        var nilai = -1;
        var innn: any = object.findIndex((o: any, index: any) => {
            if (nilai > -1) {
                return false;
            }
            if (o.id === idItem) {
                nilai = index
            }
            return false;
        });
        return nilai;

    }

    const findInArrayAdd = () => {
        var nilai = undefined;
        var innn: any = listing.addOpenTrip.file.findIndex((o: any, index: any) => {

            if ((o.id === idItem)) {
                nilai = index
            }
        });
        return nilai;
    }

    const removeItem = () => {
        const indexFile = findArrayIndex(listing.addOpenTrip.file);
        const indexImage = findArrayIndex(listing.addOpenTrip.productImages);
        listing.addOpenTrip.productImages.splice(indexImage, 1);
        listing.addOpenTrip.file.splice(indexFile, 1);
        setConfirmationModal(false);
    }

    const addDescription = () => {
        let indexFile = findInArrayAdd();

        if (indexFile !== undefined) {
            listing.addOpenTrip.file[indexFile].description = textDescriptionImage;
            // indexFile['description'] = textDescriptionImage;
        }

    }

    return (<>  <div>
        <h2 className="text-2xl font-semibold">{t('form_picture')}</h2>
        <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            {t('form_picture_desc')}
        </span>
    </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="space-y-8 block">
            <div>
                <span className="text-lg font-semibold">{t('trip_images')}</span>
                <div className="mt-5 ">
                    <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-neutral-300 dark:border-neutral-6000 border-dashed rounded-md">
                        <div className="space-y-1 text-center">
                            {loading === "image" ?
                                <div className="flex mb-2  justify-center">
                                    <Loader
                                        type="Circles"
                                        color="#d24e29"
                                        height={25}
                                        width={25}
                                    />
                                </div>
                                :
                                <svg
                                    className="mx-auto h-12 w-12 text-neutral-400"
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 48 48"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    ></path>
                                </svg>}

                            <label
                                htmlFor="file-upload"
                                className="relative cursor-pointer  rounded-md font-medium text-primary-6000 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                            >
                                <span>{t('upload_image') + "*"}</span>
                                <input
                                    id="file-upload"
                                    name="file-upload"
                                    type="file"
                                    accept="image/*"
                                    className="sr-only"
                                    onChange={(event) => uploadImage(event)}
                                />
                            </label>
                            {/* </div> */}
                            <p className="text-xs text-neutral-500 dark:text-neutral-400">
                                Landscape (PNG, JPG, GIF under 10MB)
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4  gap-3">
                {images ? (
                    images.map((im: any, key: any) => {
                        return (
                            <div key={key} className="relative border hover:shadow-xl rounded-lg" onMouseEnter={() => setshowButtonDelete(key)} onMouseLeave={() => setshowButtonDelete(null)}>
                                {showButtonDelete == key &&
                                    <div className="absolute flex-row w-full right-1 top-1">
                                        <div style={{ textAlign: 'end' }}>
                                            <button className="h-6 w-6 text-center rounded-lg mr-2" style={{ backgroundColor: '#ffffff', opacity: 0.8 }} onClick={() => {
                                                setidItem(im.id);
                                                setModalDescription(im.id);
                                                settextDescriptionImage(im.description);
                                            }} ><i className="las la-file-alt" style={{ fontSize: 24 }}></i></button>
                                            <button className="h-6 w-6 text-center rounded-lg mr-2" style={{ backgroundColor: '#ffffff', opacity: 0.8 }} onClick={() => { handleOpenModal(key) }} ><i className="las la-images" style={{ fontSize: 24 }}></i>
                                            </button>
                                            <button className="h-6 w-6 text-center rounded-lg" style={{ backgroundColor: '#ffffff', opacity: 0.8 }} onClick={() => {
                                                setidItem(im.id);
                                                setConfirmationModal(true);
                                            }} ><i className="la la-times" style={{ fontSize: 24 }}></i>
                                            </button>

                                        </div>
                                        {im.description && (
                                            <div className="rounded-lg " style={{ paddingLeft: 5, paddingRight: 5, marginLeft: 5, backgroundColor: '#ffffff', opacity: 0.8 }}>
                                                <span className="" style={{ fontSize: 12, }}>{im.description}</span>
                                            </div>
                                        )}
                                    </div>
                                }
                                <div className="absolute right-1 top-1 md:hidden block">
                                    <button className="h-6 w-6 text-center rounded-lg mr-2" style={{ backgroundColor: '#ffffff', opacity: 0.8 }} onClick={() => {
                                        setidItem(im.id);
                                        setModalDescription(im.id);
                                        settextDescriptionImage(im.description);
                                    }} ><i className="las la-file-alt" style={{ fontSize: 24 }}></i></button>
                                    <button className="h-6 w-6 text-center rounded-lg mr-2" style={{ backgroundColor: '#ffffff', opacity: 0.8 }} onClick={() => { handleOpenModal(key) }} ><i className="las la-images" style={{ fontSize: 24 }}></i>
                                    </button>
                                    <button className="h-6 w-6 text-center rounded-lg" style={{ backgroundColor: '#ffffff', opacity: 0.8 }} onClick={() => {
                                        setidItem(im.id);
                                        setConfirmationModal(true);
                                    }} ><i className="la la-times" style={{ fontSize: 24 }}></i>
                                    </button>
                                </div>
                                <img alt="" style={{ height: 100 }} className="object-cover w-full rounded-lg" src={im.urls ? getUrl(typeof im.urls == "string" ? JSON.parse(im.urls)[4] : im.urls[4]) : ''} />
                            </div>
                        )
                    })
                ) : <></>}
            </div>
            {listing?.addOpenTrip?.file ? (
                <ModalPhotos
                    imgs={listing.addOpenTrip.file}
                    isOpen={isOpen}
                    onClose={handleCloseModal}
                    initFocus={openFocusIndex}
                />
            ) : <></>
            }

            <NcModal
                isOpenProp={confimationModal}
                renderTrigger={() => { return (<div></div>); }}
                hideCloseBtn={true}
                // contentExtraClass="w-1/4"
                modalTitle={t('confirmation')}
                renderContent={() => {
                    return (
                        <div className="max-w-md">
                            <span className="text-center font-regular">
                                Are you sure want to delete this image?
                            </span>
                            <br />
                            <div className="flex flex-row w-full mt-8 space-x-4">
                                <ButtonSecondary onClick={() => setConfirmationModal(false)} className="flex-1 p-2 h-min">No</ButtonSecondary>
                                <ButtonPrimary onClick={() => {
                                    removeItem();
                                }} className="flex-1 w-full h-min p-2 ">
                                    Yes
                                </ButtonPrimary>
                            </div>
                        </div>
                    );
                }}

            />

            <NcModal
                isOpenProp={modalDescription !== null}
                renderTrigger={() => { return (<div></div>); }}
                hideCloseBtn={true}
                contentExtraClass="md:w-1/2 "
                modalTitle={"Description this image"}
                onCloseModal={() => {
                    setModalDescription(null);
                    settextDescriptionImage("");
                }}
                renderContent={() => {
                    return (
                        <div className="max-w">
                            <FormItem
                                label={"Description"}
                            >
                                <ReactTextareaAutosize value={textDescriptionImage} onChange={(e) => settextDescriptionImage(e.target.value)} minRows={3} placeholder="Description your image" className="block w-full text-sm rounded-2xl border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 mb-2" />
                            </FormItem>
                            <br />
                            <div className="flex flex-row w-full mt-8 space-x-4">
                                <ButtonSecondary onClick={() => {
                                    setModalDescription(null);
                                    settextDescriptionImage("");
                                }} className="flex-1 p-2 h-min">No</ButtonSecondary>
                                <ButtonPrimary onClick={() => {
                                    addDescription();
                                    setModalDescription(null);
                                    settextDescriptionImage("");
                                }} className="flex-1 w-full h-min p-2 ">
                                    Yes
                                </ButtonPrimary>
                            </div>
                        </div>
                    );
                }}

            />

        </div></>);
}

export default OpenStepThree;